import { gql } from "utils/urql";
import { forwardRef } from "react";
import styles from "./ArticleParagraph.module.scss";
import { ArticleParagraphFragment } from "types/api";
import cx from "classnames";

const ArticleParagraph = forwardRef<
  HTMLParagraphElement,
  ArticleParagraphFragment
>(function ArticleParagraph({ idAttr, subtype, innerHtml }, ref) {
  return (
    <p
      ref={ref}
      id={idAttr || undefined}
      className={cx(styles.root, subtype === "DROPCAP" && styles.dropcap)}
      dangerouslySetInnerHTML={{ __html: innerHtml }}
    />
  );
});

export default ArticleParagraph;

ArticleParagraph.fragment = gql`
  fragment articleParagraph on ArticleParagraphContent {
    idAttr
    subtype
    innerHtml
  }
`;
